import axiosInstance from '../utils/setupAxios';

export function fetchSyncRequestLogs(params = {}) {
  return axiosInstance.get('/songs/admin/sync-request-logs', { params });
}

export function fetchSyncRequestLogById(id) {
  return axiosInstance.get(`/songs/admin/sync-request-logs/${id}`);
}
